module.exports = __webpack_public_path__ + "img/apt-1@3x.64d6c0a5.jpg";